import _extends from "reshow-runtime/es/helpers/extends";
import React from 'react';
import { mixClass } from 'class-lib';
import SemanticUI from '../molecules/SemanticUI';

var Label = function Label(props) {
  var classes = mixClass(props.className, 'label');
  return /*#__PURE__*/React.createElement(SemanticUI, _extends({}, props, {
    className: classes
  }));
};

export default Label;